import type { TourStep } from '@/components/ui/Tour';
import { ACADEMY_SETTINGS_TOUR_STEP_IDS, TOUR_CENTERED_STEP_SELECTOR } from '../tour-constants';
import { TourStepContent } from './StepContent';

export interface AcademySettingsTourOptions {
  onEnterGeneral?: () => void;
  onEnterAdvanced?: () => void;
}

export function getAcademySettingsTourSteps(
  options: AcademySettingsTourOptions = {},
): TourStep[] {
  return [
    {
      content: (
        <TourStepContent
          title="Academy settings"
          description="Set your academy name, configure student age groups for lessons and calendars, and review advanced lesson policies when your plan includes them."
        />
      ),
      selectorId: TOUR_CENTERED_STEP_SELECTOR,
    },
    {
      content: (
        <TourStepContent
          title="Settings tabs"
          description="General settings covers your academy name and age groups. Advanced settings — waitlists, make-up credits, SMS, and related lesson policies — are available on Professional and Enterprise plans."
        />
      ),
      selectorId: ACADEMY_SETTINGS_TOUR_STEP_IDS.TABS,
      position: 'bottom',
      onStepEnter: options.onEnterGeneral,
    },
    {
      content: (
        <TourStepContent
          title="Academy name"
          description="This name appears on your lesson catalogue, owner dashboard, and family-facing academy pages."
        />
      ),
      selectorId: ACADEMY_SETTINGS_TOUR_STEP_IDS.NAME,
      position: 'top',
      onStepEnter: options.onEnterGeneral,
    },
    {
      content: (
        <TourStepContent
          title="Age groups"
          description="Define how you group students — by age range, ball colour pathway, or custom labels. Calendar colours and lesson filters use these groups across your academy."
        />
      ),
      selectorId: ACADEMY_SETTINGS_TOUR_STEP_IDS.AGE_GROUPS,
      position: 'top',
      onStepEnter: options.onEnterGeneral,
    },
    {
      content: (
        <TourStepContent
          title="Advanced settings"
          description="On Professional or Enterprise, open this tab for waitlists, make-up credits, SMS reminders, private-lesson requests, and low-enrollment alerts."
        />
      ),
      selectorId: ACADEMY_SETTINGS_TOUR_STEP_IDS.ADVANCED,
      position: 'top',
      onStepEnter: options.onEnterAdvanced,
    },
  ];
}

export const academySettingsTourSteps: TourStep[] = getAcademySettingsTourSteps();
